import axios from "axios";
import React, { useEffect, useState } from "react";
import { getSecureUser } from "../utils/secureStorage";
import { FaTimes } from "react-icons/fa";
import { FaSyncAlt } from "react-icons/fa";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";

export default function VerificationPage() {
  const [verificationState, setVerificationState] = useState([]);
  const [user, setUser] = useState({});
  const [showOTPField, setShowOTPField] = useState(true);
  const [otp, setOTP] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);
  const [showResendIcon, setShowResendIcon] = useState(false);
  const [resendTimer, setResendTimer] = useState(60); // 60 seconds for one minute
  const navigate = useNavigate()

  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  const getVerifyStatus = async () => {
    try {
      const user = getSecureUser();
      setUser(user);
      const url = `${process.env.REACT_APP_API}/secure/view_veri_status/${user.email}`;
      const res = await axios.get(url, { withCredentials: true })

      setVerificationState(res.data.data[0]);
      console.log(res);

      if (
        res.data.data[0].admin_verified &&
        res.data.data[0].email_verified &&
        res.data.data[0].mobile_verified
      ) {
        navigate("/student");
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getVerifyStatus()
    // eslint-disable-next-line
  }, []);

  function handleEmailVerification(e) {
    e.preventDefault();
    const url = `${process.env.REACT_APP_API}/secure/resend`;
    const data = {
      email: user.email,
    };
    axios
      .patch(url, data, { withCredentials: true })
      .then((res) => {
        if (res.data.success) {
          setIsSuccess(true);
          setMessage(res.data.message);
        } else {
          setIsSuccess(false);
          setMessage(
            res.data.message || "Failed to send email verification link"
          );
        }
      })
      .catch((error) => {
        setIsSuccess(false);
        setMessage(
          "An error occurred while sending the email verification link"
        );
        console.log(error);
      });
  }

  function handleResendOTP() {
    setShowOTPField(true);
    setOTP("");
    setShowResendIcon(true);
    setResendTimer(60);
    const url = `${process.env.REACT_APP_API}/sms/resend`;
    const data = {
      email: DOMPurify.sanitize(user.email, {
        ALLOWED_ATTR: [],
        ALLOWED_TAGS: [],
      }),
    };
    axios
      .patch(url, data, { withCredentials: true })
      .then((res) => {
        if (res.data.success) {
          setIsSuccess(true);
          setMessage(res.data.message);
        } else {
          setIsSuccess(false);
          setMessage(res.data.message || "Failed to send OTP");
        }
      })
      .catch((error) => {
        setIsSuccess(false);
        setMessage("An error occurred while sending the OTP");
        console.log(error);
      });
  }

  const handleOTPChange = (e) => {
    setOTP(e.target.value);
  };

  const handleSubmitOTP = (e) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_API}/sms/vs`;
    const data = {
      email: DOMPurify.sanitize(user.email, {
        ALLOWED_ATTR: [],
        ALLOWED_TAGS: [],
      }),
      otp: DOMPurify.sanitize(otp, {
        ALLOWED_ATTR: [],
        ALLOWED_TAGS: [],
      }),
    };
    axios
      .post(url, data, { withCredentials: true })
      .then((res) => {
        console.log(res.data)
        if (res.data.message === "OTP verified successfully.") {

          setIsSuccess(true);
          setMessage(res.data.message);
          setOTP("");
          setShowOTPField(false);
          getVerifyStatus();
        } else {
          setIsSuccess(false);
          setMessage(res.data.message || "Failed to send OTP");
        }
      })
      .catch((error) => {
        console.log(error);
        // Handle the error case
      });
  };

  const mainDivStyle = {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: "30px",
  };
  const handleCloseButtonClick = () => {
    window.location.hash = "/login";
  };

 

  return (
    <div style={mainDivStyle}>
      <form
        className="relative flex flex-col justify-center rounded-lg  p-8"
        style={{ backgroundColor: "#f5f5f5" }}
      >
        {/* Close Button */}
        <button
          type="button"
          className="absolute top-2 right-2"
          onClick={handleCloseButtonClick}
        >
          <FaTimes size={17} />
        </button>

        {/* Title */}
        <h3 className="text-center text-2xl font-semibold mb-4">Verification</h3>

        {/* NIGST Verification */}
        <div className="flex items-center mb-3">
          <span className="text-lg font-medium">NIGST Verification</span>
          {verificationState.admin_verified ? (
            <span className="ml-5 text-green-500 font-medium">Verified</span>
          ) : (
            <span className="ml-5 text-red-500 font-medium">Not Verified</span>
          )}
        </div>

        {/* Email Verification */}
        <div className="flex items-center mb-3">
          <span className="text-lg font-medium">Email Verification</span>
          {verificationState.email_verified ? (
            <span className="ml-5 text-green-500 font-medium">Verified</span>
          ) : (
            <>
              <span className="ml-5 text-red-500 font-medium">Not Verified</span>
              <button
                type="button"
                onClick={handleEmailVerification}
                className="ml-3 px-3 py-1 bg-blue-500 text-white rounded"
              >
                Resend Email Verification
              </button>
            </>
          )}
        </div>

        {/* Phone Verification */}
        <div className="flex items-center mb-3">
          <span className="text-lg font-medium">Phone Verification</span>
          {verificationState.mobile_verified ? (
            <span className="ml-5 text-green-500 font-medium">Verified</span>
          ) : 
            <div className="flex items-center ml-5 space-x-2">
              <input
                type="text"
                value={otp}
                onChange={handleOTPChange}
                placeholder="Enter OTP"
                className="border px-2 py-1 rounded"
              />
                <button
                  type="button"
                  disabled={resendTimer>0}
                  onClick={handleResendOTP}
                  className="text-blue-500"
                >
                  {resendTimer > 0 ? (
                    <>
                      <FaSyncAlt className="inline mr-1" /> Resend OTP ({resendTimer}s)
                    </>
                  ) : (
                    "Resend OTP"
                  )}
                </button>
              
              <button
                type="button"
                onClick={handleSubmitOTP}
                className="px-3 py-1 bg-green-500 text-white rounded"
              >
                Verify
              </button>
            </div>
          }
        </div>

        {/* Message */}
        {message && (
          <div
            className={`mt-4 p-2 text-white rounded ${isSuccess ? "bg-green-500" : "bg-red-500"
              }`}
          >
            {message}
          </div>
        )}
      </form>
    </div>

  );
}
